// extracted by mini-css-extract-plugin
export var boxItems = "_97-1";
export var boxItemsLg = "_97-2";
export var button = "_97-7";
export var buttonLg = "_97-8";
export var filterGroupBox = "_97-0";
export var icon = "_97-3";
export var iconSecondary = "_97-6";
export var iconWrapper = "_97-4";
export var iconWrapperLg = "_97-5";